import { render, staticRenderFns } from "./fenpei-dialog.vue?vue&type=template&id=252d14e6&scoped=true&"
import script from "./fenpei-dialog.vue?vue&type=script&lang=ts&"
export * from "./fenpei-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./fenpei-dialog.vue?vue&type=style&index=0&id=252d14e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252d14e6",
  null
  
)

export default component.exports